import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import useStaticPageConfig from '@modules/static-pages/composables/useStaticPageConfig';

import type {
  ISettingsInformationItemPayload,
  ISettingsInformationItemResponse,
} from '../types';
import {
  SETTINGS_INFORMATION_ITEM_QUERY_KEY,
  SETTINGS_INFORMATION_ITEM_URL,
} from '../constants';

export default function useSettingsInformationItemQuery(
  payload: Ref<ISettingsInformationItemPayload | undefined>,
): IContextQueryResult<ISettingsInformationItemResponse> {
  const { fetchGet } = useRestClient();
  const { getStaticPagePermission } = useStaticPageConfig();

  return useContextQuery<ISettingsInformationItemResponse, Error>({
    queryKey: [SETTINGS_INFORMATION_ITEM_QUERY_KEY, payload],
    queryFn: ({ signal }) => fetchGet(SETTINGS_INFORMATION_ITEM_URL, {
      signal,
      queryParams: {
        language: payload.value?.language,
      },
      urlParams: {
        page: payload.value?.page,
      },
      permission: payload.value?.page ? getStaticPagePermission(payload.value.page) : undefined,
    }),
    enabled: computed(() => !!payload.value?.page),
  });
}
